import React from "react";
import { graphql } from "gatsby";
import ReviewsGuidelinesTemplate from "@components/reviewsGuidelinesPage/reviewsGuidelinesTemplate";

const IndexPage = ({
  data: {
    prismic: {
      allReviews_guidelines: {
        edges: {
          0: { node: reviewGuidelinessData },
        },
      },
    },
  },
  pageContext,
}) => <ReviewsGuidelinesTemplate data={reviewGuidelinessData} pageContext={pageContext} />;

export const query = graphql`
query allReviews_guidelines($localeCode: String) {
  prismic {
    allReviews_guidelines(lang: $localeCode) {
      edges {
        node {
          reviews_guidelines_hero_heading
          reviews_guidelines_hero_image
          reviews_guidelines_hero_subheading
          reviews_guidelines_text
        }
      }
    }
  }
}
`;

export default IndexPage;
